import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const aguaSalada = createAsyncThunk(
    'aguaSalada/getAguaSalada',
    async () => {
        try {
            const request = await axios.get("/api/sensor/getAguaSalada")
            return request.data
        } catch (error) {
            throw error
        }
    }
)
